// John Eldhose 20180511
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Divider, Grid, IconButton, InputAdornment, Snackbar, TextField, Typography } from '@material-ui/core';
import { Contacts, Create, Email, Person, Phone, VpnKey, Visibility, VisibilityOff, Work } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { createProfile } from '../Api/createProfile';
import { loadLoginPage } from './lib/LoginPage';

class LoginSignUp extends Component {

  state = {
    subtitle: 'Shared between Carlson Cloud, Community, PhotoCapture, and Academy',
    FirstName: '',
    LastName: '',
    username: '',
    email: '',
    CompanyDescription: '',
    password: '',
    phone: '',
    showPassword: false,
    Message: '',
    errorMessage: '',
    disableSave: false
  };
  componentWillMount() {
    const LoginPage = loadLoginPage();
    switch (LoginPage !== null && LoginPage.url) {
      case '/demo':
        this.setState({ subtitle: 'Required for demo, but will also handle Carlson Cloud, Community, PhotoCapture, and Academy' });
        break;
      case '/purchase':
        this.setState({ subtitle: 'Required for purchase, but will also handle Carlson Cloud, Community, PhotoCapture, and Academy' });
        break;
      case '/renew':
        this.setState({ subtitle: 'Required to renew, but will also handle Carlson Cloud, Community, PhotoCapture, and Academy' });
        break;
      default:
    }
  }
  handleUserInput(event, lower = false) {
    this.setState({ [event.target.name]: (
      lower ? event.target.value.toLowerCase() : event.target.value
    ) });
    const error = event.target.name + 'Error';
    this.setState({ [error]: false });
  }
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  handleMouseDownPassword = event => {
    event.preventDefault();
  };
  handleSave = () => {
//    this.setState({ disableSave: true });
    var data = {
      FirstName: this.state.FirstName,
      LastName: this.state.LastName,
      username: this.state.username,
      email: this.state.email,
      CompanyDescription: this.state.CompanyDescription,
      password: this.state.password,
      phone: this.state.phone
    };
    createProfile(data)
      .then((prof) => {
        if(prof['status'] === 'true')
          this.setState({ Message: 'Account is created', errorMessage: '' });
        else {
          if(typeof prof['fields'] !== 'undefined' && prof['fields'].length > 0) {
            var fld = '';
            prof['fields'].map((field) => {
              fld = field + 'Error';
              this.setState({ [fld]: true });
              return false;
            });
          }
          if(prof['error'] !== '')
            this.setState({ Message: '', errorMessage: prof['error'] });
          else
            this.setState({ Message: '', errorMessage: 'Account creation failed' });
          this.setState({ disableSave: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ Message: '', errorMessage: 'Failed to create account', disableSave: false });
      })
  }
  clearLoginError = () => {
    this.setState({ Message: '', errorMessage: '' });
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <font color='#385687'>Carlson Customer Login</font>
        </Typography>
        <Typography variant='title'>
          <font color='black'>
          <FormattedMessage
            id='Create a Carlson account'
            defaultMessage='Create a Carlson account'
          />
          </font>
        </Typography>
        <p />
        <Typography variant='subheading'>
          {this.state.subtitle}
        </Typography>
        <p />
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Button component={Link} to='/' fullWidth variant='raised' color='primary'>
              <FormattedMessage
                id='Already have an account? Sign In'
                defaultMessage='Already have an account? Sign In'
              />
            </Button>
          </Grid>
        </Grid>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Contacts className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='First Name'
                defaultMessage='First Name'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='FirstName'
                    value={this.state.FirstName}
                    error={this.state.FirstNameError}
                    helperText={this.state.FirstNameHelper}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Contacts className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Last Name'
                defaultMessage='Last Name'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='LastName'
                    value={this.state.LastName}
                    error={this.state.LastNameError}
                    helperText={this.state.LastNameHelper}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Email className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Email Address'
                defaultMessage='Email Address'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='email'
                    value={this.state.email}
                    error={this.state.emailError}
                    helperText={this.state.emailHelper}
                    onChange={(event) => this.handleUserInput(event, true)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Work className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Company Name'
                defaultMessage='Company Name'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='CompanyDescription'
                    value={this.state.CompanyDescription}
                    error={this.state.CompanyDescriptionError}
                    helperText={this.state.CompanyDescriptionHelper}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Person className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Username'
                defaultMessage='Username'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='username'
                    value={this.state.username}
                    error={this.state.usernameError}
                    helperText={this.state.usernameHelper}
                    onChange={(event) => this.handleUserInput(event, true)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <VpnKey className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Password'
                defaultMessage='Password'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='password'
                    type={this.state.showPassword ? 'text' : 'password'}
                    value={this.state.password}
                    error={this.state.passwordError}
                    onChange={(event) => this.handleUserInput(event)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.handleClickShowPassword}
                            onMouseDown={this.handleMouseDownPassword}
                          >
                            {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Phone className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Work Phone'
                defaultMessage='Work Phone'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='phone'
                    value={this.state.phone}
                    error={this.state.phoneError}
                    helperText={this.state.phonelHelper}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>

        <p />
        <Button
          variant='raised'
          color='primary'
          fullWidth
          onClick={this.handleSave}
          disabled={this.state.disableSave}
        >
          <FormattedMessage
            id='Sign Up'
            defaultMessage='Sign Up'
          /> &nbsp;
          <Create />
        </Button>
        <p />
        <Divider />
        <p />
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Button component={Link} to='/' fullWidth>
              <FormattedMessage
                id='Return to Login'
                defaultMessage='Return to Login'
              />
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.Message !== '' || this.state.errorMessage !== ''}
          onClose={this.clearLoginError}
          message={
            <span>
              {this.state.Message}
              <span style={{ color: 'red' }}>
                {this.state.errorMessage}
              </span>
            </span>
          }
        />
      </div>
    );
  }
}

export default LoginSignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp.js